import React, { useState } from 'react';
import { useTranslation } from "react-i18next";
import Axios from "../../Axios";
import Select from 'react-select';
import { useSearchParams  } from 'react-router-dom';
import { HmacSHA1 } from 'crypto-js';
import AreYouSure, { AYSButton } from '../AreYouSure.tsx';

export function ForgetPasswordComponent() {
    const { t, i18n } = useTranslation();
    const [ params ] = useSearchParams ();
    const [ showAlert, setAlert ] = useState();

    const lngs = {
        en: { nativeName: "English", flag: "/svg/en.svg" },
        fr: { nativeName: "Français", flag: "/svg/fr.svg" },
    };

    const sendData = async (data, path) => {
        if ( data.password !== data.confirm_password ) {
            setAlert( 
                <AreYouSure
                    title = { t( 'Warning' ) }
                    message = { t( "Invalid password confirmation" ) }
                    buttons={[
                              <AYSButton
                                text = { t( 'Ok' ) }
                                callback = { e => setAlert( undefined ) }
                                type = "cancel"
                              /> ] }
                    callback = { res => {
                        setAlert( undefined )
                        return null;
                    } }
                />)
        } else {
            data.email = params.get("email"); 
            data.password = HmacSHA1( data.password, process.env.REACT_APP_SECRET_PASSWORD ).toString()
            const response = await Axios.post('/api/auth/password/' + path, data);
            if ( response.status === 201 ) {
                window.location.href = "/login";
            } else {
                setAlert( 
                    <AreYouSure
                        title = { t( 'Warning' ) }
                        message = { response.data.msg }
                        buttons={[
                                  <AYSButton
                                    text = { t( 'Ok' ) }
                                    callback = { e => setAlert( undefined ) }
                                    type = "cancel"
                                  /> ] }
                        callback = { res => {
                            setAlert( undefined )
                            return null;
                        } }
                    />)
            }
        }
    };

    const handleChangeLanguage = (selectedOption) => {
        i18n.changeLanguage(selectedOption.value);
    };

    const options = Object.keys(lngs).map(lng => ({
        value: lng,
        label: (
            <div className="flex items-center">
                <img src={lngs[lng].flag} alt={lng} className="rounded-full w-8 h-8 inline mr-2" />
                {lngs[lng].nativeName}
            </div>
        )
    }));

    return (
        <>
        <div className="max-w-md mx-auto mt-8 min-w-96">
           
            <h1 className="text-xl text-gray-600">{t('forget_password_title')}</h1>
            <div className="mt-4">
                <label htmlFor="code" className="block">{t('Code')}</label>
                <input type="text" id="code" placeholder={t('Code')} className="mt-1 p-2 border rounded-md w-full"/>
                <label htmlFor="password" className="block">{t('Password')}</label>
                <input type="password" id="password" placeholder={t('Password')}
                       className="mt-1 p-2 border rounded-md w-full"/>
                <label htmlFor="confirm_password" className="block">{t('Confirm Password')}</label>
                <input type="password" id="confirm_password" placeholder={t('Confirm Password')}
                       className="mt-1 p-2 border rounded-md w-full"/>
                <button onClick={() => sendData({
                    code: document.getElementById("code").value,
                    password: document.getElementById("password").value,
                    confirm_password: document.getElementById("confirm_password").value
                }, "verify")} className="mt-2 bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded w-full">
                    {t('Change Password')}
                </button>
            </div>
            <div className="mt-4 text-center">
                <Select
                    name="language"
                    id="language"
                    options={options}
                    onChange={handleChangeLanguage}
                    value={options.find(option => option.value === i18n.language)}
                    className="select_language"
                    classNamePrefix="select"
                />
            </div>
        </div>
        { showAlert }
        </>
    );
}
